<template>
  <div :class="[$style.sidebarNavInner, { [$style.mini]: isMini }]">
    <SidebarSearch v-model="localModelValue" :nodes :is-mini="isMini" />
    <SidebarNavSettingsDropdown
      v-if="showSettings"
      :search-active="!!localModelValue"
      :is-mini="isMini"
      :set-all-expanded="setAllExpanded"
      :all-expanded="allExpanded"
      :all-collapsed="allCollapsed"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { NavNode } from "@/utils/navUtils";

import SidebarNavSettingsDropdown from "./SidebarNavSettingsDropdown.vue";
import SidebarSearch from "./SidebarSearch.vue";

const props = defineProps<{
  modelValue: string;
  isMini: boolean;
  showSettings: boolean;
  nodes?: NavNode[];
  setAllExpanded?: (expanded: boolean) => void;
  allExpanded?: boolean;
  allCollapsed?: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

const localModelValue = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});
</script>

<style lang="scss" module>
.sidebarNavInner {
  display: flex;
  width: 100%;
  gap: var(--dimension-100);
}

.mini {
  flex-direction: column;
  gap: var(--space-component-padding-small);
}

.searchInput {
  display: flex;
  align-items: center;
  height: 28px;
  max-height: 28px;
  width: 100%;
}
</style>
